import styles from "../../ErrorBoundary.module.css";

interface RecoveryActionsProps {
  isClearing: string | null;
  onReload: () => void;
  onClearSession: () => void;
  onClearConfig: () => void;
  onUpdate: () => void;
  onFreshInstall: () => void;
}

export const RecoveryActions = ({
  isClearing,
  onReload,
  onClearSession,
  onClearConfig,
  onUpdate,
  onFreshInstall,
}: RecoveryActionsProps) => {
  return (
    <>
      <div className={styles.primaryAction}>
        <button
          className={styles.primaryButton}
          onClick={onReload}
          disabled={isClearing !== null}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Reload App
        </button>
      </div>

      <div className={styles.recoverySection}>
        <p className={styles.sectionLabel}>Recovery options</p>
        <div className={styles.recoveryGrid}>
          <button
            className={styles.recoveryButton}
            onClick={onClearSession}
            disabled={isClearing !== null}
          >
            {isClearing === "session" ? "Clearing..." : "Clear Session"}
            <span className={styles.recoveryButtonHint}>
              Removes current session shots
            </span>
          </button>

          <button
            className={styles.recoveryButton}
            onClick={onClearConfig}
            disabled={isClearing !== null}
          >
            {isClearing === "config" ? "Clearing..." : "Clear Configuration"}
            <span className={styles.recoveryButtonHint}>
              Resets facility setup
            </span>
          </button>

          <button
            className={styles.recoveryButton}
            onClick={onUpdate}
            disabled={isClearing !== null}
          >
            {isClearing === "update" ? "Updating..." : "Check for Update"}
            <span className={styles.recoveryButtonHint}>No data loss</span>
          </button>

          <button
            className={styles.dangerButton}
            onClick={onFreshInstall}
            disabled={isClearing !== null}
          >
            <span className={styles.dangerButtonLabel}>
              {isClearing === "fresh" ? "Resetting..." : "Fresh Install"}
            </span>
            <span className={styles.recoveryButtonHint}>
              Deletes all local data
            </span>
          </button>
        </div>
      </div>

      <div className={styles.supportFooter}>
        <div className={styles.supportText}>
          <p className={styles.supportLabel}>Need help?</p>
          <p className={styles.supportUrl}>support.trackmangolf.com</p>
        </div>
        <div className={styles.qrCode}>
          <img
            src="/assets/support-qr-code.png"
            alt="Support QR Code"
            width="80"
            height="80"
          />
        </div>
      </div>
    </>
  );
};
